import React, { useMemo, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tabs from '../components/common/Tabs';
import PlayerDashboard from './PlayerDashboard';
import { Heading, Text, Typography } from '../components/common/Typography';
import { Card } from '../components/common/Card';
import { BackButton } from '../components/common';
import AccountSettings from './AccountSettings';
import RecentSessionCard from '../components/player/RecentSessionCard';
import PendingJoinRequestsCard from '../components/profile/PendingJoinRequestsCard';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const PlayerProfilePage = ({ currentUser, onUserUpdate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = useQuery();

  const tabParam = query.get('tab');
  const validTabs = ['performance', 'partnerships', 'headtohead', 'account'];
  
  // Redirect legacy 'overview' tab to 'performance'
  useEffect(() => {
    if (tabParam === 'overview') {
      const newParams = new URLSearchParams(location.search);
      newParams.set('tab', 'performance');
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    }
  }, [tabParam, location.search, location.pathname, navigate]);
  
  const initialTab = validTabs.includes(tabParam) ? tabParam : 'performance';

  const tabs = [
    {
      id: 'performance',
      label: 'Performance',
      icon: '📊',
      content: (
        <PlayerDashboard currentUser={currentUser} embedded activeView="summary" />
      ),
    },
    {
      id: 'partnerships',
      label: 'Partnerships',
      icon: '🤝',
      content: (
        <PlayerDashboard currentUser={currentUser} embedded activeView="partnerships" />
      ),
    },
    {
      id: 'headtohead',
      label: 'Matchups',
      icon: '🥊',
      content: (
        <PlayerDashboard currentUser={currentUser} embedded activeView="headtohead" />
      ),
    },
    {
      id: 'account',
      label: 'Account Settings',
      icon: '⚙️',
      content: (
        <AccountSettings currentUser={currentUser} onUserUpdate={onUserUpdate} embedded />
      ),
    },
  ];

  return (
    <div>
      <div className="mb-4">
        <BackButton onClick={() => navigate('/')}>
          Back to Home
        </BackButton>
      </div>
      <div className="mb-6">
        <Typography variant="h2" className="mb-1">
          Player Profile
        </Typography>
        <Text className="text-slate-600">
          Explore your badminton performance, partnerships, and history.
        </Text>
      </div>

      {/* Quick Actions Section */}
      <div className="mb-8">
        <Heading level={3} className="mb-4 text-text-primary">
          Quick Actions
        </Heading>
        <RecentSessionCard currentUser={currentUser} />
        <div className="mt-4">
          <PendingJoinRequestsCard currentUser={currentUser} />
        </div>
      </div>

      <Tabs
        tabs={tabs}
        defaultTab={initialTab}
      />
    </div>
  );
};

export default PlayerProfilePage;


